export default __webpack_public_path__ + "static/media/baunebakken-floorplan-4-rooms-small.414e74ea.png";